import React from 'react'
import styles from './ModalValidacionPersonas.module.css'

const ModalValidacionPersonas = ({ viap, personID, accion}) => {
    const handleChangePersona = (valor) => {
        accion(valor)
    }

    return (
        <React.Fragment>
            <div className={`${styles['w3-modal']} ${styles['show-modal-beneficiaries']}`}>
                <div className={styles['w3-modal-content']}>
                    <div className={styles['w3-header']}></div>
                    <div className={styles['w3-container']}>
                        <p className={styles['w3title']}>
                            El buscador de personas identificó datos diferentes para el documento consultado. Selecciona con qué opción vas a completar la información.
                        </p>
                        <div className={styles['comparativo']}>
                            <div className={styles['personid']} onClick={() => handleChangePersona(1)}>
                                <div className={styles['caja']}><h3 className={styles['titulo']}>Person ID</h3></div>
                                <p className={styles['textos']}>
                                    <strong>Nombre: </strong>{personID.nombres}
                                </p>
                                <p className={styles['textos']}>
                                    <strong>Apellido Paterno: </strong>{personID.apellidoPaterno}
                                </p>
                                <p className={styles['textos']}>
                                    <strong>Apellido Materno: </strong>{personID.apellidoMaterno}
                                </p>
                                <p className={styles['textos']}>
                                    <strong>Sexo: </strong>{personID.sexo === 'M' ? 'Masculino' : personID.sexo === 'F' ? 'Femenino' : ''}
                                </p>
                                <p className={styles['textos']}>
                                    <strong>Fecha de nacimiento: </strong>{personID.fechaNacimiento}
                                </p>
                            </div>
                            <div className={styles['viap']} onClick={() => handleChangePersona(2)}>
                                <div className={styles['caja']}><h3 className={styles['titulo']}>VIAP</h3></div>
                                <p className={styles['textos']}>
                                    <strong>Nombre: </strong>{viap.nombres}
                                </p>
                                <p className={styles['textos']}>
                                    <strong>Apellido Paterno: </strong>{viap.apellidoPaterno}
                                </p>
                                <p className={styles['textos']}>
                                    <strong>Apellido Materno: </strong>{viap.apellidoMaterno}
                                </p>
                                <p className={styles['textos']}>
                                    <strong>Sexo: </strong>{viap.sexo === 'M' ? 'Masculino' : viap.sexo === 'F' ? 'Femenino' : ''}
                                </p>
                                <p className={styles['textos']}>
                                    <strong>Fecha de nacimiento: </strong>{viap.fechaNacimiento}
                                </p>
                            </div>
                        </div>
                        <p className={styles['w3title']}>
                            En caso ninguna de las opciones sea correcta, selecciona una opción y edita los datos manualmente.
                        </p>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default ModalValidacionPersonas